import {
  FaAddressCard,
  FaInfoCircle,
  FaMailBulk,
  FaPhoneAlt,
  FaQrcode,
  FaRegAddressCard,
  FaUserCheck,
  FaWpforms,
} from "react-icons/fa";
import Collabse from "../../../components/Collabse";
import { useAppSelector } from "../../../redux/store";
import HolidayDestinations from "./HolidayDestinations";
import TravelParticipants from "./TravelParticipants";
import TravelPeriod from "./TravelPeriod";
import { useTranslation } from "react-i18next";

const MainInfo = () => {
  const { t } = useTranslation();
  const booking = useAppSelector((state) => state.booking);

  return (
    <Collabse Header={Header}>
      <div className="row row-cols-1 row-cols-lg-4">
        <div className="col">
          <div className="d-flex gap-3">
            <p>
              <FaQrcode />
            </p>
            <p>{booking.bookingOverview.orderNo}</p>
          </div>

          <div className="d-flex gap-3">
            <p>
              <FaUserCheck />
            </p>
            <p>{booking.bookingOverview.fullName}</p>
          </div>

          <div className="d-flex gap-3">
            <p>
              <FaWpforms />
            </p>
            <p>
              {t("bookingDetails.overview.bookingStatus")}:{" "}
              {booking.bookingOverview.bookingStatus}
            </p>
          </div>
        </div>

        <div className="col">
          <TravelPeriod />
          <TravelParticipants />
        </div>

        <div className="col">
          <HolidayDestinations />
        </div>

        <div className="col">
          <h5 className="d-lg-none">
            <FaInfoCircle className="me-2" />
            {t("bookingDetails.overview.title2")}
          </h5>

          <div className="d-flex gap-3">
            <p>
              <FaAddressCard />
            </p>

            <div>
              <p className="m-0">{booking.travelAgency?.addressLine}</p>
              <p className="m-0">
                {booking.travelAgency?.street} {booking.travelAgency?.streetNo}
              </p>
              <p className="m-0">
                {booking.travelAgency?.postalCode} {booking.travelAgency?.city}
              </p>
            </div>
          </div>

          <div className="d-flex gap-3">
            <p className="m-0">
              <FaPhoneAlt />
            </p>
            <p className="m-0">{booking.travelAgency?.phoneBusiness}</p>
          </div>

          <div className="d-flex gap-3">
            <p className="m-0">
              <FaMailBulk />
            </p>
            <p className="m-0 uu">
              {booking.travelAgency?.email?.replace(/\./g, ".\u200B")}
            </p>
          </div>
        </div>
      </div>
    </Collabse>
  );
};

const Header = () => {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div className="col-12 col-lg-9">
        <h5>
          <FaRegAddressCard /> {t("bookingDetails.overview.title1")}
        </h5>
      </div>
      <div className="col-12 col-lg-3 d-none d-lg-block">
        <h5>
          <FaInfoCircle />
          {t("bookingDetails.overview.title2")}
        </h5>
      </div>
    </div>
  );
};

export default MainInfo;
